import script from "./MfaSmsConfirmView.vue?vue&type=script&setup=true&lang=ts"
export * from "./MfaSmsConfirmView.vue?vue&type=script&setup=true&lang=ts"

import "./MfaSmsConfirmView.vue?vue&type=style&index=0&id=3c6e3eea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c6e3eea"]])

export default __exports__